import React from 'react';
import styled, { css } from 'styled-components';
import { black, blue } from '@avangard/ui/colors';

type HintProps = {
    children: React.ReactNode;
    dense?: boolean;
    className?: string;
};

const Hint = (props: HintProps): React.ReactElement => {
    const { dense, children, className } = props;

    return (
        <Root className={className} dense={dense}>
            {children}
        </Root>
    );
};

const Root = styled.div<Pick<HintProps, 'dense'>>`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 8px 16px;
    color: ${black[80]};
    font-size: 1.4rem;
    line-height: 22px;
    border: 1px solid ${blue[40]};
    border-radius: 4px;
    background-color: ${blue[10]};

    ${p =>
        !!p.dense &&
        css`
            padding: 4px 16px;
        `}
`;

export { Hint };
